import { bindSitePagePartialClick } from '../../SitePagePartial/Scripts/site-page-partial';

const rekAiWrapperSelector = '.rekai-news-wrapper, .rekai-newsarticle-wrapper';
const rekAiHeaderSelector = '.rekai-news-header-wrapper';

// wrap Rek AI header in section__head div
function styleRekaiHeader(header: HTMLElement) {
    if (header.closest('.section__head')) {
        // already fixed this one, no need to do anything more.
        return;
    }

    const parent = header.parentElement;
    if (!parent) {
        return;
    }

    const wrapper = document.createElement('div');
    wrapper.classList.add('section__head');
    parent.insertBefore(wrapper, header);
    wrapper.appendChild(header);
}

function getFallBackImageSrc(): string {
    const host = (window as any).__staticHost ?? '';
    return `${host}/assets/images/fallback-image.png`;
}

function styleRekaiCard(card: HTMLElement) {
    if (card.dataset.rekaiStyled === '1') {
        // only style once
        return;
    }
    card.dataset.rekaiStyled = '1';

    // we don't want these classes
    card.classList.remove(
        'rek-m-bottom--x-small',
        'rek-p-bottom--x-small',
        'rekai-newsarticle-article-container'
    );

    // make the outer container behave like a site page partial link block puff (try saying that fast 5 times!)
    card.classList.add(
        'section__item',
        'section__item--third',
        'site-page-partial',
    );

    // Rek AI inner wrapper - we expect this to exist
    const originalInner = card.querySelector('.rekai-newsarticle-article') as HTMLElement | null;
    if (!originalInner) {
        return;
    }

    // <article class="site-page-partial__content">
    const article = document.createElement('article');
    article.classList.add('site-page-partial__content');

    // move all children from Rek div into article
    while (originalInner.firstChild) {
        article.appendChild(originalInner.firstChild);
    }
    card.replaceChild(article, originalInner);

    // add image classes
    const imgWrapper = card.querySelector('.rekai-newsarticle-img-wrapper') as HTMLElement | null;
    const img = imgWrapper?.querySelector('.rekai-newsarticle-img') as HTMLImageElement | null;

    if (imgWrapper) {
        imgWrapper.classList.remove('rek-m-bottom--x-small', 'rekai-newsarticle-img-wrapper');
        imgWrapper.classList.add('site-page-partial__image-container');
    }

    if (img) {
        const src = img.getAttribute('src');
        if (!src || src === '') {
            img.setAttribute('src', getFallBackImageSrc());
        }
        img.classList.add('site-page-partial__image');
    }

    // Add text containers
    const textContainer = document.createElement('div');
    textContainer.classList.add('site-page-partial__text-container');

    const textContent = document.createElement('div');
    textContent.classList.add('site-page-partial__text-content');

    const link = article.querySelector('.rekai-newsarticle-a') as HTMLAnchorElement | null;
    const teaser = article.querySelector('.rekai-newsarticle-p') as HTMLElement | null;

    if (link) {
        link.classList.add('site-page-partial__link');

        const h3 = document.createElement('h3');
        h3.classList.add('site-page-partial__heading', 'heading');

        link.parentNode?.removeChild(link);
        h3.appendChild(link);
        textContent.appendChild(h3);
    }

    if (teaser) {
        teaser.classList.add('site-page-partial__text');
        textContent.appendChild(teaser);
    }

    // and the icon!
    const iconContainer = document.createElement('div');
    iconContainer.classList.add('site-page-partial__icon-container');

    const icon = document.createElement('span');
    icon.classList.add('site-page-partial__icon', 'icon');
    iconContainer.appendChild(icon);

    textContainer.appendChild(textContent);
    textContainer.appendChild(iconContainer);

    article.appendChild(textContainer);
    bindSitePagePartialClick(article);
}

function puffifyRekBlock(rekWrapper: HTMLElement) {
    const sectionContainer = rekWrapper?.parentElement as HTMLElement | null;
    if (!sectionContainer) {
        return;
    }

    // we only puffify once
    if (sectionContainer.dataset.rekPuffed === '1') {
        return;
    }
    sectionContainer.dataset.rekPuffed = '1';

    // move all cards out of the wrapper and into the section container
    while (rekWrapper.firstElementChild) {
        const child = rekWrapper.firstElementChild as HTMLElement;

        sectionContainer.appendChild(child);
    }

    rekWrapper.remove();

    // style the cards according to our own site page partial link blocks
    sectionContainer
        .querySelectorAll('.rekai-newsarticle-article-container')
        .forEach(el => styleRekaiCard(el as HTMLElement));
}

function processRekaiMarkup(root: ParentNode) {
    const rootElement = root instanceof HTMLElement ? root : null;

    if (rootElement?.matches(rekAiHeaderSelector)) {
        styleRekaiHeader(rootElement);
    }

    root
        .querySelectorAll(rekAiHeaderSelector)
        .forEach(el => styleRekaiHeader(el as HTMLElement));

    if (rootElement?.matches(rekAiWrapperSelector)) {
        puffifyRekBlock(rootElement);
        return;
    }

    root
        .querySelectorAll(rekAiWrapperSelector)
        .forEach(el => puffifyRekBlock(el as HTMLElement));
}

const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
            if (!(node instanceof HTMLElement)) {
                return;
            }

            processRekaiMarkup(node);
        });
    });
});

processRekaiMarkup(document);

// start watching the entire document body
observer.observe(document.body, {
    childList: true,
    subtree: true
});
